export default "__VITE_ASSET__BK3cLwWk__"